import { Resolution } from "@/sdk"

// API 接口返回的错误，包括 HTTP 错误和业务错误
export class HttpAPIError {
  constructor(
    readonly code: number,
    readonly msg?: string,
    readonly data?: any
  ) {}
}

export type APIResponse<T> = T | HttpAPIError

// HTTP 请求错误
export class HttpReqError {
  constructor(
    readonly path?: string,
    readonly status?: number
  ) {}
}

// 设备状态
export interface DeviceStateRes {
  desktopID: string
  gateWayIP: string
  // 云电脑所属机房 id。接口 JSON 字段为 node。
  node?: string
  // 云电脑公网出口 IP
  desktopPublicIp?: string
  serverPrivateIp: string
  status: string
}

// 设备列表信息
export interface DeviceInfoRes {
  desktopID: string
  deviceID: number
  deviceName: string
  gateWayIP: string
  online: string
  serverPrivateIp: string
  status: string
  // os: string
  businessStatus: string
  // 客户端是否允许发起重启
  canRestart: boolean
  // 云电脑公网出口 IP
  desktopPublicIp?: string
  // 云电脑所属机房 id。接口 JSON 字段为 node。
  node?: string
}
// 设备列表信息（旧的）
export interface OldDeviceInfoRes {
  ID: number
  CreatedAt: string
  UpdatedAt: string
  deviceID: number
  deviceName: string
  ipAddr: string
  lastAddr: string
  userID: number
  compID: number
  os: string
  online: string
  connected: string
  version: string
  account: string
  outID: string
  desktopID: string
  serverPrivateIp: string
  region: string
  info: {
    mouse_mode: string
    hardware_type: string
    monitor_label: string
    business_scene: string
  }
  supplierID: string
}

// 登录返回参数
export interface LoginRes {
  user: {
    AccountID: number
    userName: string
    nickName: string
    headerImg: string
    phone: string
    email: string
  }
  token: string
  companyUniqID: number
  list: DeviceInfoRes[]
  // 是否需要提示修改初始密码
  needChangePassword: boolean
  // 修改密码提示文案
  changePasswordMessage: string
}

// 图片验证码
export interface ImgCodeRes {
  captchaId: string
  picPath: string
  captchaLength: number
}

export interface AppPreference {
  // 鼠标滚轮速度比例，范围 0～1
  mouseScrollSpeed?: number
  // 鼠标滚轮方向 跟随 Mac 使用习惯
  isUseMacMouseWheelDir: boolean
  // 复制粘贴（和常见快捷键）跟随 Mac 使用习惯
  isUseCommonShortcut: boolean
  // 游戏模式开关
  isGameModel?: boolean
  // 用户设置的分辨率(存储在localstorage中)
  resolutionItem: Resolution
  // 用户多久未操作云电脑自动退出 的时间间隔
  autoLogoutTimeGap: AutoLogoutTimeGap
  // 当前桌面壁纸 resource_id
  currentDeskWallpaperId?: string
}

export type AutoLogoutTimeGap =
  | "five_minutes"
  | "ten_minutes"
  | "thirty_minutes"
  | "one_hour"
  | "time_never"

export interface WallpaperImageRes {
  img: string
  img_thumb: string
  resource_id: string
}

export interface WallpaperThemeRes {
  theme_id: string
  title: string
  images: WallpaperImageRes[]
}

export interface WallpaperListRes {
  list: WallpaperThemeRes[]
}

// ===== 客户端动态配置（对齐 android ClientConfigData）=====

export interface UdiskConfig {
  enable: number
  read: number
  write: number
}

export interface VideoConfig {
  averageBitrate: number
  displayMaxHeight: number
  displayMaxRefreshRate: number
  displayMaxWidth: number
  dynamicFpsEnable: number
  encoder?: string
  maxBitrate: number
  maxFps: number
  yuv444: number
}

export interface ClientConfigData {
  enableClipboard: number
  enableDebug: number
  enableFileTransfer: number
  enableLogUpload: number
  logUploadUrl?: string
  logUploadRequestId?: string
  softwareBlackList?: unknown[]
  udisk?: UdiskConfig
  usbDeviceList?: unknown[]
  user?: string
  version?: string
  videoConfig?: VideoConfig
}

// /api/client-config 响应的完整结构（含 HTTP 状态与 ETag，用于 ETag 条件请求）
export interface ClientConfigRawResp {
  code: number
  msg: string
  data: ClientConfigData | null
  requestId: string
}

export interface ClientConfigResult {
  statusCode: number
  etag?: string
  code?: number
  msg?: string
  requestId?: string
  data?: ClientConfigData | null
}
